import React, { useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { Link, Card, Grid, ListItemText, Typography } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

import { Dimensions, LoadingSpinner } from '../../../../components';
import { PublishableStatusComponent } from '../../../../components/PublishableStatusComponent';

import ModelDetailsCad from './ModelDetailsCad';
import ModelDetailsImages from './ModelDetailsImages';

import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { Exception } from '@jewelutions/core-common-domain';
import { GQLParty, GQLPieceModel } from '@jewelutions/core-crm-server-api-client-domain';
import PieceModelUpdateDialog from '../PieceModelUpdateDialog';
import { PlatformNavigation } from '../../navigation/PlatformNavigation';
import { successNotification } from '../../../../core/utils';
import { toast } from 'react-toastify';
import { Box } from '../../../../types-hack';
interface IProps {
  party: GQLParty;
}

const PieceModelDetails: React.FC<IProps> = ({ party }) => {
  const [isUpdatePieceModelDialogOpen, setIsUpdatePieceModelDialogOpen] = useState(false);

  const { pieceId, pieceModelId } = PlatformNavigation.pieceModelDetails.paramsFromPath(useRouteMatch());

  const mapResponseToModel = (data: any): GQLPieceModel => {
    const pieceModel = GQLOperationBuilder.piece
      .pieceAssetFromResponse(data)
      .piece.models.find(model => model.id === pieceModelId);
    if (pieceModel === undefined)
      throw new Exception(`Cannot locate piece model ${pieceModelId} in GQL piece data`);
    return pieceModel;
  };

  const { data, loading, error, networkStatus, refetch } = GQLOperationBuilder.piece.getPiece({
    pieceId: pieceId
  });

  if (loading) return <LoadingSpinner />;
  if (!data) return null;

  return (
    <div>
      <Card>
        <Box p={5}>
          <div style={{ display: 'flex' }}>
            <Typography style={{ marginRight: '2px' }} variant={'h6'}>
              Piece Model Details
            </Typography>
            <EditIcon
              fontSize="small"
              style={{ cursor: 'pointer' }}
              onClick={() => setIsUpdatePieceModelDialogOpen(true)}
            />
          </div>

          <PublishableStatusComponent
            text="Piece model publishable"
            status={mapResponseToModel(data).isPublishable}
          ></PublishableStatusComponent>

          <Grid container direction="column" justify={'space-between'}>
            <Grid item xs={12} md={4}>
              <Grid container direction="column" justify="center">
                <ListItemText primary="Size" secondary={mapResponseToModel(data).sizeType} />
                <ListItemText primary="Stones" secondary={mapResponseToModel(data).stonesPlacementType} />
                <ListItemText
                  primary="Dimension"
                  secondary={<Dimensions dimensions3D={mapResponseToModel(data).dimensions} />}
                />
                <ListItemText primary="Size" secondary={mapResponseToModel(data).sizeType} />
                {mapResponseToModel(data).hasCadFileValid && (
                  <Link href={mapResponseToModel(data).cadFile!.url!}>Download piece CAD</Link>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Card>

      <Card style={{ margin: '8px 0' }}>
        <Box p={5}>
          <Grid container direction="column" justify={'space-between'}>
            <Grid item xs={12} md={4}>
              <Grid container direction="column" justify="center">
                <ModelDetailsImages pieceId={pieceId} model={mapResponseToModel(data)} />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Card>

      <Card style={{ margin: '8px 0' }}>
        <Box p={5}>
          <div style={{ display: 'flex' }}>
            <Typography style={{ marginRight: '2px' }} variant={'h6'}>
              Model Availability
            </Typography>
          </div>
          <Grid container direction="column" justify="center">
            {mapResponseToModel(data).availableConfigurations.map(ac => {
              return (
                <ListItemText
                  primary={`${ac.platingType}, ${ac.materialType}, ${ac.sizeType}`}
                  secondary={`Weight: ${
                    mapResponseToModel(data).weights.find(
                      w => w.configuration.platingType === ac.platingType
                    )!.weightInGrams
                  }g`}
                />
              );
            })}
          </Grid>
        </Box>
      </Card>

      <ModelDetailsCad pieceId={pieceId} model={mapResponseToModel(data)} />

      {isUpdatePieceModelDialogOpen && (
        <PieceModelUpdateDialog
          pieceId={pieceId}
          model={mapResponseToModel(data)}
          party={party}
          onClose={success => {
            if (success === true) {
              successNotification(toast, 'Piece model updated successfully', () => {});
            }

            setIsUpdatePieceModelDialogOpen(false);
            refetch();
          }}
        />
      )}
    </div>
  );
};

export default PieceModelDetails;
